<onsip-loading-container [deferCond]="isDataObtained$">
  <onsip-header-main>
    <onsip-header-page-title> External phone number </onsip-header-page-title>
    @if (hasExternalPhoneNumbers | async) {
    <onsip-header-action-bar>
      <mat-form-field appearance="outline">
        <input
          matInput
          [formControl]="search"
          [placeholder]="'ONSIP_I18N.SEARCH' | translate"
          [attr.data-cy]="E2eLocators.ADMIN_EXT_PHONE_NUM_SEARCH"
          autocomplete="off"
        />
        <mat-icon matSuffix color="primary">search</mat-icon>
      </mat-form-field>
      <button
        mat-stroked-button
        onsip-header-secondary-action
        color="primary"
        [attr.data-cy]="E2eLocators.ADMIN_EXT_PHONE_NUM_ADD_BTN"
        [routerLink]="views.ADMIN_EXTERNAL_PHONE_NUMBER_SETUP"
      >
        Add external phone number
      </button>
    </onsip-header-action-bar>
    }
  </onsip-header-main>
  @if (hasExternalPhoneNumbers | async) {
  <div>
    <onsip-table-two
      class="ext-phone-num-table"
      matSort
      multiTemplateDataRows
      [dataSource]="dataSource"
      [trackBy]="trackByAddressId"
      [useGrid]="true"
      [hoverable]="true"
    >
      <!-- NAME -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{
          "ONSIP_I18N.NAME" | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let extPhoneNum">
          <span class="ext-phone-num-cell-content">{{ extPhoneNum.name }}</span>
        </mat-cell>
      </ng-container>
      <!-- EXTERNAL PHONE NUMBER -->
      <ng-container matColumnDef="externalPhoneNumber">
        <mat-header-cell *matHeaderCellDef mat-sort-header>External phone number</mat-header-cell>
        <mat-cell *matCellDef="let extPhoneNum">
          <span class="ext-phone-num-cell-content">{{ extPhoneNum.username | e164 }}</span>
        </mat-cell>
      </ng-container>
      <!-- OUTBOUND CALLER ID -->
      <ng-container matColumnDef="outboundCallerId">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Outbound caller id</mat-header-cell>
        <mat-cell *matCellDef="let extPhoneNum">
          <span class="ext-phone-num-cell-content">{{ extPhoneNum.callerIdName }}</span>
        </mat-cell>
      </ng-container>
      <!-- ACTIONS -->
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let extPhoneNum" class="actions-cell">
          <mat-icon color="primary" class="expand-button">{{
            selectedRows.includes(extPhoneNum.addressId) ? "expand_less" : "expand_more"
          }}</mat-icon>
          <button
            [attr.data-cy]="E2eLocators.ADMIN_EXT_PHONE_NUM_REMOVE_BTN"
            mat-icon-button
            (click)="removeItem(extPhoneNum, $event)"
            color="primary"
            class="delete-button"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </mat-cell>
      </ng-container>
      <!-- SHELF -->
      <ng-container matColumnDef="expanded">
        <onsip-table-shelf-cell
          *matCellDef="let extPhoneNum"
          [attr.colspan]="displayedColumns.length"
          [expanded]="selectedRows.includes(extPhoneNum.addressId)"
        >
          @if (selectedRows.includes(extPhoneNum.addressId)) { @if ((isEditMode$ | async) === false)
          {
          <onsip-external-phone-number-shelf-view
            [externalPhoneNum]="extPhoneNum"
            (startEditing)="isEditMode$.next(true)"
          >
          </onsip-external-phone-number-shelf-view>
          } @if (isEditMode$ | async) {
          <onsip-external-phone-number-shelf-edit
            [externalPhoneNum]="extPhoneNum"
            (cancelEditing)="isEditMode$.next(false)"
          >
          </onsip-external-phone-number-shelf-edit>
          } }
        </onsip-table-shelf-cell>
      </ng-container>
      <!-- ROWS -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        [attr.data-cy]="E2eLocators.ADMIN_EXT_PHONE_NUM_ROW"
        (click)="
          selectedRows.includes(row.addressId)
            ? selectedRows.splice(selectedRows.indexOf(row.addressId), 1)
            : selectedRows.push(row.addressId)
        "
      >
      </mat-row>
      <onsip-table-shelf *matRowDef="let row; columns: ['expanded']"></onsip-table-shelf>
      <div *matNoDataRow class="no-data-row">
        @if (!dataSource.data.length || !search.value) {
        <span
          translate
          [translateParams]="{ value: 'ONSIP_I18N.ANNOUNCEMENTS' | translate | lowercase }"
        >
          ONSIP_I18N.YOU_HAVENT_ADDED_ANY_VALUE_YET
        </span>
        } @if (search.value && dataSource.data.length) {
        <span>
          {{ "ONSIP_I18N.NO_RESULTS" | translate }}
        </span>
        }
      </div>
    </onsip-table-two>
    <mat-paginator
      onsip-paginator-primary-icon
      showFirstLastButtons
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
    >
    </mat-paginator>
    <div class="contact-tagline">
      <span>
        {{ "ONSIP_I18N.NEED_HELP_CONTACT_OUR" | translate }}
        <a [routerLink]="views.CONTACT_SUPPORT" class="primary-500">{{
          "ONSIP_I18N.SUPPORT_TEAM" | translate | titlecase
        }}</a>
      </span>
    </div>
  </div>
  } @if ((hasExternalPhoneNumbers | async) === false) {
  <div class="empty-state">
    <div class="mat-headline-4 ext-phone-num-setup-title">Add an external phone number</div>
    <div class="mat-body-2 ext-phone-num-setup-text">
      External Phone Numbers allow you to route calls to phone numbers on the PSTN just like
      internal extensions. Add extension-to-extension dialing for a cell phone number or route an
      attendant menu option to an external number.
    </div>
    <button
      mat-flat-button
      [routerLink]="views.ADMIN_EXTERNAL_PHONE_NUMBER_SETUP"
      color="primary"
      [attr.data-cy]="E2eLocators.ADMIN_EXT_PHONE_NUM_ADD_BTN"
      class="ext-phone-num-setup-button"
    >
      Set up external phone number
    </button>
    <div class="mat-body-2 ext-phone-num-pricing">Pricing: Free</div>
  </div>
  }
</onsip-loading-container>
